module.exports = __webpack_public_path__ + "img/reception-0.e3cb5afc.svg";